import { TYPE } from '@kontentino/kontentino-constants/Pages';
import PageTypeUtils from 'app/utils/pageType';
import type { AnalyticsPlatform } from 'api/new-analytics/types';

export function analyticsPlatformToPageType(
  platform: AnalyticsPlatform,
): number {
  return PageTypeUtils.getNumberFromName(platform);
}

export function pageTypeToAnalyticsPlatform(
  pageType: number,
): AnalyticsPlatform | undefined {
  if (pageType === TYPE.FACEBOOK) {
    return 'facebook';
  }
  if (pageType === TYPE.INSTAGRAM) {
    return 'instagram';
  }
  if (pageType === TYPE.LINKEDIN) {
    return 'linkedin';
  }
  if (pageType === TYPE.TIKTOK) {
    return 'tiktok';
  }
  return undefined;
}
